<template>
    <div>
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-2">
                        <button  class="btn btn--icon btn--white" @click.prevent="handleBack('/')">
                            <i class="material-icons">keyboard_arrow_left</i>
                        </button>
                    </div>

                    <div class="col-8">
                        <h1 class="header__title">Find Room</h1>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <div id="add-room-code"  class="row add-room-code simple-form simple-form--horizontal mb--lg">
                <div class="col-12">
                    <div class="row">
                        <div class="col col-input">
                          <input type="text" v-model="roomCode" @keyup.enter="findRoom()" placeholder="Room code" class="form-control text--left" />
                        </div>
                        <div class="col col-button">
                          <button type="button" @click="findRoom" class="btn btn--block btn--primary">
                              <i class="material-icons">keyboard_arrow_right</i>
                          </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 mb--lg">
                    <div class="">
                      <h2 class="postbox__title text--center">Rooms</h2>
                    </div>

                    <div class="row">
                        <div class="col-6">
                            <select class="form-control mb--md" v-model.number="filterLevel">
                                <option value="0">All level</option>
                                <option v-for="(level, id) in levels" :value="id">{{ level }}</option>
                            </select>
                        </div>
                        <div class="col-6">
                            <select class="form-control mb--md" v-model="filterGameType">
                                <option value="all">All categories</option>
                                <option v-for="(gameType, key) in gameTypes" :value="key"> {{ gameType }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div id="rooms" class="rooms row">
                <div class="col-12" v-for="channel in filteredChannels">
                    <div @click="goToChannel(channel)" class="panel bg--layer-dark mb--md">
                        <div class="room__list">
                            <div class="room__list__item">
                                <div class="profile profile--inline profile--horizontal profile--sm">
                                    <figure class="profile__avatar">
                                        <span class="profile__avatar__img">
                                            <img v-bind:src="channel.creator_avatar" alt="" />
                                        </span>
                                    </figure>

                                    <div class="profile__text">
                                        <div class="profile__name">
                                            <span>{{ channel.name }}</span>
                                            <div class="locked" v-show="channel.is_locked">
                                                <img src="/img/icons/locked-outline.svg" alt="Locked Room" />
                                            </div>
                                        </div>

                                        <div class="game__info weight--normal">
                                            <div>
                                                <img v-bind:src="channel.game_type_icon" v-bind:alt="channel.type" />
                                                <span>{{ gameTypes[channel.type] }} / Level {{ channel.level }}</span>
                                            </div>

                                            <div class="number-of-employees text--right">
                                                <img src="/img/icons/user-orange.svg" alt="" />
                                                <span v-if="channel.number_of_participants">{{ channel.active_participants }} / {{ channel.number_of_participants }}</span>
                                                <span v-else>{{ channel.active_participants }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <modal show="false" type="error" ref="validationModal">
                <template v-slot:message>
                    <div v-if="errors.any()">
                        <div v-for="error in errors.all()">{{ error }}</div>
                    </div>
                </template>

                <template v-slot:title>
                    Error
                </template>

                <template v-slot:buttons><span></span></template>
            </modal>
      </section>
    </div>
</template>

<script>
    import api from "../../api/channels";
    import Errors from "../../util/Errors";
    import internalBackRoute from "../../mixins/internalBackRoute";

    export default {
        name: "ChannelList",

        data: function () {
            return {
                channels: [],
                gameTypes: [],
                levels: {
                    1: 'Level 1',
                    2: 'Level 2',
                    3: 'Level 3',
                    4: 'Level 4',
                },
                timer: '',
                filterGameType: 'all',
                filterLevel: 0,
                roomCode: null,
                errors: new Errors(),
            }
        },

        mixins: [internalBackRoute],

        computed: {
            filteredChannels() {
                let filteredChannels = this.channels
                if (this.filterGameType != 'all') {
                    filteredChannels = filteredChannels.filter(channel => channel.type === this.filterGameType)
                }

                if (this.filterLevel) {
                    filteredChannels = filteredChannels.filter(channel => channel.level === this.filterLevel)
                }

                return filteredChannels
            },
        },

        methods: {
            async loadChannels() {
                try {
                    let response = await api.channels()
                    this.channels = response.data.data
                } catch (e) {
                    Quiz.$emit('channels-load-error')
                }
            },

            async loadTypes() {
                try {
                    let response = await api.gameTypes()
                    this.gameTypes = response.data
                } catch (e) {
                    Quiz.$emit('channels-load-game-types-error')
                }
            },

            async findRoom() {
                try {
                    let response = await api.findChannel(this.roomCode)

                    let channel = response.data.data

                    this.goToChannel(channel)
                } catch (error) {
                    this.errors.record(error.response.data.errors)
                    this.$refs.validationModal.open()
                }
            },

            goToChannel(channel) {
                this.$router.push(channel.url);
            }
        },

        created () {
            this.loadChannels()
            this.loadTypes()
            this.timer = setInterval(this.loadChannels, 5000)
        },

        beforeDestroy() {
            clearInterval(this.timer)
        }
    }
</script>